/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `auto` - 자동
 * `manual` - 직접 입력
 * `reference` - 참고곡 기반
 */
export type DefaultGenerationModeEnum =
  (typeof DefaultGenerationModeEnum)[keyof typeof DefaultGenerationModeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DefaultGenerationModeEnum = {
  auto: "auto",
  manual: "manual",
  reference: "reference",
} as const;
